import React from "react";
import { getImgPath } from "../common/helper";

import {
  t,
  HEADING1_1,
  HEADING1_2,
  HEADING2,
  HEADING3,
  CENTRAL_GOV_REP,
  NON_OFFICIAL,
  INVITEE,
  NAME1_L1,
  NAME1_L2,
  NAME1_L3,
  NAME1_L4,
  NAME1_L5,
  NAME2_L1,
  NAME2_L2,
  NAME2_L3,
  NAME2_L4,
  NAME3_L1,
  NAME3_L2,
  NAME3_L3,
  NAME3_L4,
  DIRECTOR,
  OFFICIAL,
  NAME4_L1,
  NAME4_L2,
  NAME4_L3,
  NAME4_L4,
  NAME5_L1,
  NAME5_L2,
  NAME5_L3,
  NAME6_L1,
  NAME6_L2,
  NAME6_L3,
  NAME7_L1,
  NAME7_L2,
  NAME7_L3,
  NAME8_L1,
  NAME8_L2,
  NAME8_L3,
  NAME9_L1,
  NAME9_L2,
  NAME9_L3,
  NAME10_L1,
  NAME10_L2,
  NAME10_L3,
  NAME11_L1,
  NAME11_L2,
  NAME11_L3,
  NAME11_L4,
  NAME12_L1,
  NAME12_L2,
  NAME12_L3,
  NAME12_L4,
  NAME13_L1,
  NAME13_L2,
  NAME13_L3,
  NAME14_L1,
  NAME14_L2,
  NAME14_L3,
  NAME14_L4,
  NAME15_L1,
  NAME15_L2,
  NAME15_L3,
  NAME15_L4,
} from "../../translations/AboutUs/Management";
import { tAboutUsCommon, CLICK_HERE } from "../../translations/AboutUs/Common";

function Management() {
  return (
    <div
      className="management"
      style={{
        width: "80%",
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "flex-start",
        flexDirection: "column",
        gap: 15,
        paddingRight: 10,
      }}
    >
      <div className="a-normal" style={{ fontWeight: 700, textAlign: "left" }}>
        {t(HEADING1_1)}{" "}
        <a
          href="https://ksrtc.karnataka.gov.in"
          target="_blank"
          style={{ color: "#004f9e" }}
        >
          {tAboutUsCommon(CLICK_HERE)}
        </a>
        {t(HEADING1_2)}
      </div>
      <div className="a-large" style={{ fontWeight: 600, textAlign: "left" }}>
        {t(HEADING2)}
      </div>
      <div className="a-normal" style={{ fontWeight: 500, textAlign: "left" }}>
        {t(HEADING3)}
      </div>
      <table border={1}>
        <thead style={{ backgroundColor: "#e5f3ff", height: 48 }}>
          <tr>
            <th style={{ border: "none" }}>Sl.No.</th>
            <th style={{ border: "none" }}>Names</th>
            <th style={{ border: "none" }}>Official/Non-Official</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style={{ verticalAlign: "top" }}>1</td>
            <td style={{ padding: 0 }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  justifyContent: "space-between",
                }}
              >
                <div style={{ padding: 8, lineHeight: "20px" }}>
                  <span style={{ fontWeight: 600 }}>{t(NAME1_L1)}</span>,
                  <br />
                  {t(NAME1_L2)}
                  <br />
                  {t(NAME1_L3)}
                  <br />
                  {t(NAME1_L4)}
                </div>
                <div
                  style={{
                    border: "1px solid lightgrey",
                    borderTop: "none",
                    borderBottom: "none",
                  }}
                >
                  <img
                    src={getImgPath("/img/aboutus/management/img1.png")}
                    alt=""
                  />
                </div>
              </div>
            </td>
            <td style={{ textAlign: "center" }}>{t(NAME1_L5)}</td>
          </tr>
          <tr>
            <td style={{ verticalAlign: "top" }}>2</td>
            <td style={{ padding: 0 }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  justifyContent: "space-between",
                }}
              >
                <div style={{ padding: 8, lineHeight: "20px" }}>
                  <span style={{ fontWeight: 600 }}>{t(NAME2_L1)}</span>
                  <br />
                  {t(NAME2_L2)}
                  <br />
                  {t(NAME2_L3)}
                </div>
                <div
                  style={{
                    border: "1px solid lightgrey",
                    borderTop: "none",
                    borderBottom: "none",
                    padding: 11,
                  }}
                >
                  <div
                    style={{
                      width: 140,
                      height: 168,
                      border: "1px solid lightgrey",
                    }}
                  />
                </div>
              </div>
            </td>
            <td style={{ textAlign: "center" }}> {t(NAME2_L4)}</td>
          </tr>
          <tr>
            <td style={{ verticalAlign: "top" }}>3</td>
            <td style={{ padding: 0 }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  justifyContent: "space-between",
                }}
              >
                <div style={{ padding: 8, lineHeight: "20px" }}>
                  <span style={{ fontWeight: 600 }}>{t(NAME3_L1)}</span>
                  <br />
                  {t(NAME3_L2)}
                  <br />
                  {t(NAME3_L3)}
                  <br />
                  {t(NAME3_L4)}
                </div>
                <div
                  style={{
                    border: "1px solid lightgrey",
                    borderTop: "none",
                    borderBottom: "none",
                  }}
                >
                  <img
                    src={getImgPath("/img/aboutus/management/img2.png")}
                    alt=""
                  />
                </div>
              </div>
            </td>
            <td style={{ textAlign: "center" }}>
              {t(DIRECTOR)}
              <br />
              {t(OFFICIAL)}
            </td>
          </tr>
          <tr>
            <td style={{ verticalAlign: "top" }}>4</td>
            <td style={{ padding: 0 }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  justifyContent: "space-between",
                }}
              >
                <div style={{ padding: 8, lineHeight: "20px" }}>
                  <span style={{ fontWeight: 600 }}>{t(NAME4_L1)}</span>
                  <br />
                  {t(NAME4_L2)}
                  <br />
                  {t(NAME4_L3)}
                  <br />
                  {t(NAME4_L4)}
                </div>
                <div
                  style={{
                    border: "1px solid lightgrey",
                    borderTop: "none",
                    borderBottom: "none",
                    padding: 11,
                  }}
                >
                  <div
                    style={{
                      width: 140,
                      height: 168,
                      border: "1px solid lightgrey",
                    }}
                  />
                </div>
              </div>
            </td>
            <td style={{ textAlign: "center" }}>
              {t(DIRECTOR)}
              <br />
              {t(OFFICIAL)}
            </td>
          </tr>
          <tr>
            <td style={{ verticalAlign: "top" }}>5</td>
            <td style={{ padding: 0 }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  justifyContent: "space-between",
                }}
              >
                <div style={{ padding: 8, lineHeight: "20px" }}>
                  <span style={{ fontWeight: 600 }}>{t(NAME5_L1)}</span>
                  <br />
                  {t(NAME5_L2)}
                  <br />
                  {t(NAME5_L3)}
                </div>
                <div
                  style={{
                    border: "1px solid lightgrey",
                    borderTop: "none",
                    borderBottom: "none",
                    padding: 12,
                  }}
                >
                  <img
                    src={getImgPath("/img/aboutus/management/img3.png")}
                    alt=""
                  />
                </div>
              </div>
            </td>
            <td style={{ textAlign: "center" }}>
              {t(DIRECTOR)}
              <br />
              {t(OFFICIAL)}
            </td>
          </tr>
          <tr>
            <td style={{ verticalAlign: "top" }}>6</td>
            <td style={{ padding: 0 }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  justifyContent: "space-between",
                }}
              >
                <div style={{ padding: 8, lineHeight: "20px" }}>
                  <span style={{ fontWeight: 600 }}>{t(NAME6_L1)}</span>
                  <br />
                  {t(NAME6_L2)}
                  <br />
                  {t(NAME6_L3)}
                </div>
                <div
                  style={{
                    border: "1px solid lightgrey",
                    borderTop: "none",
                    borderBottom: "none",
                    padding: 12,
                  }}
                >
                  <img
                    src={getImgPath("/img/aboutus/management/img4.png")}
                    alt=""
                  />
                </div>
              </div>
            </td>
            <td style={{ textAlign: "center" }}>
              {t(DIRECTOR)}
              <br />
              {t(OFFICIAL)}
            </td>
          </tr>
          {/* Continue adding the rest of the data in a similar manner */}
          <tr>
            <td style={{ verticalAlign: "top" }}>7</td>
            <td style={{ padding: 0 }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  justifyContent: "space-between",
                }}
              >
                <div style={{ padding: 8, lineHeight: "20px" }}>
                  <span style={{ fontWeight: 600 }}>{t(NAME7_L1)}</span>
                  <br />
                  {t(NAME7_L2)}
                  <br />
                  {t(NAME7_L3)}
                </div>
                <div
                  style={{
                    border: "1px solid lightgrey",
                    borderTop: "none",
                    borderBottom: "none",
                    padding: 12,
                  }}
                >
                  <img
                    src={getImgPath("/img/aboutus/management/img5.png")}
                    alt=""
                  />
                </div>
              </div>
            </td>
            <td style={{ textAlign: "center" }}>
              {t(DIRECTOR)}
              <br />
              {t(OFFICIAL)}
            </td>
          </tr>
          <tr>
            <td style={{ verticalAlign: "top" }}>8</td>
            <td style={{ padding: 0 }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  justifyContent: "space-between",
                }}
              >
                <div style={{ padding: 8, lineHeight: "20px" }}>
                  <span style={{ fontWeight: 600 }}>{t(NAME8_L1)}</span>
                  <br />
                  {t(NAME8_L2)}
                  <br />
                  {t(NAME8_L3)}
                </div>
                <div
                  style={{
                    border: "1px solid lightgrey",
                    borderTop: "none",
                    borderBottom: "none",
                    padding: 12,
                  }}
                >
                  <img
                    src={getImgPath("/img/aboutus/management/img6.png")}
                    alt=""
                  />
                </div>
              </div>
            </td>
            <td style={{ textAlign: "center" }}>
              {t(DIRECTOR)}
              <br />
              {t(OFFICIAL)}
            </td>
          </tr>
          <tr>
            <td style={{ verticalAlign: "top" }}>9</td>
            <td style={{ padding: 0 }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  justifyContent: "space-between",
                }}
              >
                <div style={{ padding: 8, lineHeight: "20px" }}>
                  <span style={{ fontWeight: 600 }}>{t(NAME9_L1)}</span>
                  <br />
                  {t(NAME9_L2)}
                  <br />
                  {t(NAME9_L3)}
                </div>
                <div
                  style={{
                    border: "1px solid lightgrey",
                    borderTop: "none",
                    borderBottom: "none",
                    padding: 11,
                  }}
                >
                  <div
                    style={{
                      width: 140,
                      height: 168,
                      border: "1px solid lightgrey",
                    }}
                  />
                </div>
              </div>
            </td>
            <td style={{ textAlign: "center" }}>
              {t(DIRECTOR)}
              <br />
              {t(OFFICIAL)}
            </td>
          </tr>
          <tr>
            <td style={{ verticalAlign: "top" }}>10</td>
            <td style={{ padding: 0 }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  justifyContent: "space-between",
                }}
              >
                <div style={{ padding: 8, lineHeight: "20px" }}>
                  <span style={{ fontWeight: 600 }}>{t(NAME10_L1)}</span>
                  <br />
                  {t(NAME10_L2)}
                  <br />
                  {t(NAME10_L3)}
                </div>
                <div
                  style={{
                    border: "1px solid lightgrey",
                    borderTop: "none",
                    borderBottom: "none",
                    padding: 11,
                  }}
                >
                  <div
                    style={{
                      width: 140,
                      height: 168,
                      border: "1px solid lightgrey",
                    }}
                  />
                </div>
              </div>
            </td>
            <td style={{ textAlign: "center" }}>
              {t(DIRECTOR)}
              <br />
              {t(OFFICIAL)}
            </td>
          </tr>
          <tr>
            <td style={{ verticalAlign: "top" }}>11</td>
            <td style={{ padding: 0 }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  justifyContent: "space-between",
                }}
              >
                <div style={{ padding: 8, lineHeight: "20px" }}>
                  <span style={{ fontWeight: 600 }}>{t(NAME11_L1)}</span>
                  <br />
                  {t(NAME11_L2)}
                  <br />
                  {t(NAME11_L3)}
                  <br />
                  {t(NAME11_L4)}
                </div>
                <div
                  style={{
                    border: "1px solid lightgrey",
                    borderTop: "none",
                    borderBottom: "none",
                    padding: 12,
                  }}
                >
                  <img
                    src={getImgPath("/img/aboutus/management/img7.png")}
                    alt=""
                  />
                </div>
              </div>
            </td>
            <td style={{ textAlign: "center" }}>
              {t(DIRECTOR)}
              <br />
              {t(OFFICIAL)}
              <br />
              {t(CENTRAL_GOV_REP)}
            </td>
          </tr>
          <tr>
            <td style={{ verticalAlign: "top" }}>12</td>
            <td style={{ padding: 0 }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  justifyContent: "space-between",
                }}
              >
                <div style={{ padding: 8, lineHeight: "20px" }}>
                  <span style={{ fontWeight: 600 }}>{t(NAME12_L1)}</span>
                  <br />
                  {t(NAME12_L2)}
                  <br />
                  {t(NAME12_L3)}
                  <br />
                  {t(NAME12_L4)}
                </div>
                <div
                  style={{
                    border: "1px solid lightgrey",
                    borderTop: "none",
                    borderBottom: "none",
                    padding: 11,
                  }}
                >
                  <div
                    style={{
                      width: 140,
                      height: 168,
                      border: "1px solid lightgrey",
                    }}
                  />
                </div>
              </div>
            </td>
            <td style={{ textAlign: "center" }}>
              {t(DIRECTOR)}
              <br />
              {t(NON_OFFICIAL)}
            </td>
          </tr>
          <tr>
            <td style={{ verticalAlign: "top" }}>13</td>
            <td style={{ padding: 0 }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  justifyContent: "space-between",
                }}
              >
                <div style={{ padding: 8, lineHeight: "20px" }}>
                  <span style={{ fontWeight: 600 }}>{t(NAME13_L1)}</span>
                  <br />
                  {t(NAME13_L2)}
                  <br />
                  {t(NAME13_L3)}
                </div>
                <div
                  style={{
                    border: "1px solid lightgrey",
                    borderTop: "none",
                    borderBottom: "none",
                    padding: 11,
                  }}
                >
                  <div
                    style={{
                      width: 140,
                      height: 168,
                      border: "1px solid lightgrey",
                    }}
                  />
                </div>
              </div>
            </td>
            <td style={{ textAlign: "center" }}>
              {t(DIRECTOR)}
              <br />
              {t(NON_OFFICIAL)}
            </td>
          </tr>
          <tr>
            <td style={{ verticalAlign: "top" }}>14</td>
            <td style={{ padding: 0 }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  justifyContent: "space-between",
                }}
              >
                <div style={{ padding: 8, lineHeight: "20px" }}>
                  <span style={{ fontWeight: 600 }}>{t(NAME14_L1)}</span>
                  <br />
                  {t(NAME14_L2)}
                  <br />
                  {t(NAME14_L3)}
                  <br />
                  {t(NAME14_L4)}
                </div>
                <div
                  style={{
                    border: "1px solid lightgrey",
                    borderTop: "none",
                    borderBottom: "none",
                    padding: 11,
                  }}
                >
                  <div
                    style={{
                      width: 140,
                      height: 168,
                      border: "1px solid lightgrey",
                    }}
                  />
                </div>
              </div>
            </td>
            <td style={{ textAlign: "center" }}>
              {t(DIRECTOR)}
              <br />
              {t(NON_OFFICIAL)}
            </td>
          </tr>
          <tr>
            <td style={{ verticalAlign: "top" }}>15</td>
            <td style={{ padding: 0 }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  justifyContent: "space-between",
                }}
              >
                <div style={{ padding: 8, lineHeight: "20px" }}>
                  <span style={{ fontWeight: 600 }}>{t(NAME15_L1)} IFS</span>,
                  <br />
                  {t(NAME15_L2)}
                  <br />
                  {t(NAME15_L3)}
                  <br />
                  {t(NAME15_L4)}
                </div>
                <div
                  style={{
                    border: "1px solid lightgrey",
                    borderTop: "none",
                    borderBottom: "none",
                    padding: 11,
                  }}
                >
                  <div
                    style={{
                      width: 140,
                      height: 168,
                      border: "1px solid lightgrey",
                    }}
                  />
                </div>
              </div>
            </td>
            <td style={{ textAlign: "center" }}>
              {t(INVITEE)}
              <br />
              {t(OFFICIAL)}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}

export default Management;
